import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {AnyToDo} from '../../../typings/todo';
import {Duration} from '../Duration/Duration';
import styles from './ControlBar.scss';
import {NextButton} from './NextButton/NextButton';
import {PlayPauseButton} from './PlayPauseButton/PlayPauseButton';
import {PreviousButton} from './PreviousButton/PreviousButton';
import {ProgressIndicator} from './ProgressIndicator/ProgressIndicator';

export class ControlBar extends React.Component<AnyToDo> {
  static propTypes = {
    isPlaying: PropTypes.bool,
    progress: PropTypes.number,
    duration: PropTypes.number,
    onPlayPauseClick: PropTypes.func,
    onPreviousClick: PropTypes.func,
    onNextClick: PropTypes.func,
    onProgressChange: PropTypes.func,
    isNavigationButtonsHidden: PropTypes.bool,
  };

  render() {
    const {
      isPlaying = false,
      isNavigationButtonsHidden = false,
      progress,
      onPlayPauseClick,
      onPreviousClick,
      onNextClick,
      onProgressChange,
      duration,
    } = this.props;
    const className = classNames(styles.controlBarWrapper, {[styles.hideNavigationButton]: isNavigationButtonsHidden});

    return (
      <section className={className}>
        <div className={styles.controlBar}>
          <PreviousButton className={styles.previousButton} onClick={onPreviousClick} />
          <div className={styles.playPauseContainer}>
            <PlayPauseButton isPlaying={isPlaying} onClick={onPlayPauseClick} />
            <ProgressIndicator
              className={styles.progressIndicator}
              progress={progress}
              duration={duration}
              onProgressChange={onProgressChange}
            />
          </div>
          <NextButton className={styles.nextButton} onClick={onNextClick} />
        </div>
        <Duration duration={duration} progress={progress} />
      </section>
    );
  }
}
